/**
 * Gemini (Google) Adapter — INTERFACE ONLY. No SDK, no network, no key.
 *
 * Integration mirrors the OpenAI adapter: install @google/generative-ai,
 * provide an API key, implement generate() mapping the shared prompt shape
 * onto Gemini's `functionDeclarations` / `toolConfig`, and register the
 * instance. Gemini function calls arrive as `functionCall` parts — return
 * them as { type: 'function_call', name, arguments }.
 */

import { AIProvider, NotImplementedError } from '../providerInterface';

export class GeminiAdapter extends AIProvider {
  constructor({ apiKey = null, model = 'gemini-2.0-flash' } = {}) {
    super({
      id: 'gemini',
      name: 'Gemini (not connected)',
      capabilities: { functionCalling: true, streaming: true, offline: false },
    });
    this.apiKey = apiKey;
    this.model = model;
  }

  isReady() {
    return false;
  }

  async generate() {
    throw new NotImplementedError(
      'Gemini is not connected yet. Install @google/generative-ai, provide an API key, and implement GeminiAdapter.generate() — see README.md.'
    );
  }
}
